import { Grid } from "@mui/material";
import ThemeContext from "components/app/Context";
import { setSavedFilterByType, updateCorpSavedFilters } from "components/common/Filters/Filters.slice";
import { filterPage, filterPayloadForSelectAllFeature } from "components/common/Filters/FiltersHelper";
import GlobalFilterDescription from "components/common/Filters/GlobalFilterDescription";
import GlobalFilters from "components/common/Filters/GlobalFilters";
import { setPageFilter } from "components/common/Filters/GlobalFilters.slice";
import Basictabs from "components/common/Tabs";
import Typography from "components/common/Typography";
import { useTranslate } from "hooks/useTranslate";
import React, { useContext } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { resetAllSorting } from "redux/sorting.slice";
import { tokens } from "styles/Tokens";
import { responseTypes } from "utils/Types";
import { setCorpSearchText, setCorpViewSelectedTab } from "../CorpUser.Slice";
import "./CorpView.scss";
import ModalHandler from "./ModalHandler";
import { tabDetails } from "./TabsConfig";

interface Props {
  selectedListFiltersList?: any;
  selectedList?: any;
  view?: string;
  selectedListType?: any;
}

const CorpView = (props: Props) => {
  const dispatch = useAppDispatch();
  const translate = useTranslate();

  const { view = "myList", selectedListType, selectedList } = props;
  const page =
    selectedListType === "consultant"
      ? filterPage.consultantListDisplay
      : view === "myList"
      ? filterPage.listDisplay
      : filterPage.dashboardDisplay;

  const selectedTabs = useAppSelector((state) => state.CorpDashboard.selectedTabs);
  const globalFiltersforPage = useAppSelector((state) => state.globalFilters[page]);
  const { isMobileScreen } = useContext(ThemeContext);

  const getSelectedTab = (val: number, type = view) => {
    dispatch(setCorpViewSelectedTab({ type, val }));
  };

  const updateFilters = async () => {
    let parentObject: any = {
      id: selectedList?.id,
      filters: filterPayloadForSelectAllFeature(globalFiltersforPage?.modifiedFilter)
    };
    if (selectedListType === "dynamic")
      parentObject = {
        ...parentObject,
        name: selectedList?.name,
        description: selectedList?.description,
        isFlagged: "N"
      };

    const props = {
      [selectedListType]: [parentObject]
    };
    const response = await dispatch(updateCorpSavedFilters(props));
    if (response.payload.status < responseTypes.success_threshold) {
      const payload = {
        data: response.payload[selectedListType],
        type: selectedListType
      };
      dispatch(setSavedFilterByType(payload)); //update default filters in filters slice

      dispatch(
        setPageFilter({
          pageName: selectedListType === "dynamic" ? filterPage.listDisplay : filterPage.dashboardDisplay,
          defaultFilter: globalFiltersforPage?.modifiedFilter?.filter((item: any) => item?.options?.length),
          modifiedFilter: []
        })
      ); //update default & modified in global filters
    }
  };

  return (
    <>
      <Grid
        className="corp-view-component"
        display={"flex"}
        flexDirection={isMobileScreen ? "column" : "row"}
        justifyContent={"space-between"}
        alignItems={"left"}
      >
        <div>
          <Typography variant={"h4"} showBold className="corp-view-heading" component={"div"}>
            {view === "dashboard" ? "Filtered View" : selectedList?.name}
          </Typography>
          {selectedListType === "bookmarked" && (
            <Typography variant={"label"} component={"div"} color={tokens.Text.General.PrimaryBody}>
              {translate("common.defaultSystemList")}
            </Typography>
          )}
        </div>
        <div className="corp-view-filters">
          <GlobalFilters
            isGlobalCheckBoxApplicable={view === "dashboard"}
            isDefaultButtonsApplicable={selectedListType === "default" || selectedListType === "dynamic"}
            page={page}
            updateSavedFilter={updateFilters}
          />
        </div>
      </Grid>

      <GlobalFilterDescription isGlobalCheckBoxApplicable={view === "dashboard"} page={page} />

      {(selectedListType === "static" || selectedListType === "consultant") && selectedList?.description && (
        <div className="corp-view-list-description">
          <Typography variant="label">{selectedList?.description}</Typography>
        </div>
      )}

      <Basictabs
        shouldAppendTabParam
        tabDetails={tabDetails(view, selectedListType, selectedList)}
        alignItems="left"
        labelVariant="body2"
        retainFilters
        backgroundColor={tokens.Background.General.Primary}
        selectedTab={getSelectedTab}
        defaultTab={selectedTabs[view]}
        onTabChangeFn={() => {
          dispatch(resetAllSorting({}));
          dispatch(setCorpSearchText({ view: view, value: "" }));
        }}
      />
      <ModalHandler />
    </>
  );
};
export default React.memo(CorpView);
